import React from 'react';
import DemoStage from '../DemoStage.jsx';

/**
 * Animated walkthrough of the tag combobox: open the picker, type, pick a
 * matching tag from the shared list — then try the locked system tag and get
 * a polite refusal (shake). Deliberately shows PICKING an existing tag, not
 * creating one: this demo plays for every writer, and creating new tags is
 * Interactive demo of the case tag picker (assign existing tags). Reuses the real tag classes from CaseTags.jsx
 * (.tag-pill, .tag-system, .tag-add-btn, .tag-combobox-input, .tag-menu).
 * Placeholder data only.
 */

const STEPS = [
  {
    caption: 'Tags are pills on the case header — the lock means the app added that one itself.',
    scene: 'idle', ms: 2600,
    cursor: 'add',
  },
  {
    caption: 'Open the picker…',
    scene: 'idle', ms: 1200,
    cursor: 'add', click: true,
  },
  {
    caption: 'Start typing — matching tags from the shared list appear as you go.',
    scene: 'typing', ms: 2400,
    cursor: 'pick',
  },
  {
    caption: 'Pick “follow-up”.',
    scene: 'typing', ms: 1200,
    cursor: 'pick', click: true,
  },
  {
    caption: 'The pill lands on the case — you can filter by it in All Cases straight away.',
    scene: 'added', ms: 2400,
  },
  {
    caption: 'Locked tags have no remove × — sp_migrated can’t be taken off by hand.',
    scene: 'shake', ms: 2800,
    cursor: 'locked', click: true,
  },
];

const LockIcon = () => (
  <svg className="tag-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export default function TagComboDemo() {
  return (
    <DemoStage steps={STEPS} label="Adding a tag — and why the locked one refuses" height={170}>
      {(step) => {
        const scene = step?.scene ?? 'idle';
        const open = scene === 'typing';
        const hasNew = scene === 'added' || scene === 'shake';
        return (
          <div className="kb-mock">
            <style>{'@keyframes kb-tag-shake{0%,100%{transform:translateX(0)}20%,60%{transform:translateX(-4px)}40%,80%{transform:translateX(4px)}}'}</style>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
              <span
                className="badge tag-pill tag-system"
                data-kb-target="locked"
                style={scene === 'shake' ? { animation: 'kb-tag-shake 400ms var(--ease)' } : undefined}
              >
                <LockIcon />
                sp_migrated
              </span>

              {hasNew && (
                <span className={`badge tag-pill${scene === 'added' ? ' kb-pop' : ''}`}>
                  follow-up
                  <button type="button" className="tag-x" tabIndex={-1} aria-hidden="true">×</button>
                </span>
              )}

              <div className="tag-combobox">
                {!open ? (
                  <button type="button" className="tag-add-btn" tabIndex={-1} data-kb-target="add">
                    <span aria-hidden="true">+</span> Add tag
                  </button>
                ) : (
                  <>
                    <input
                      className="tag-combobox-input"
                      value="foll"
                      readOnly
                      tabIndex={-1}
                      aria-label="Search tags"
                    />
                    <div className="tag-menu dd-shell">
                      <div className="tag-menu-item dd-item active" data-kb-target="pick">
                        follow-up
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      }}
    </DemoStage>
  );
}
